export default __webpack_public_path__ + "static/503.a55de2479df6aada92248954ea1dd767.svg";